// extracted by mini-css-extract-plugin
export var bottom = "bF_s";
export var contact = "bF_gD";
export var faqCat = "bF_gM";
export var faqCatDescription = "bF_gQ";
export var faqCatTitle = "bF_gP";
export var faqCategories = "bF_gL";
export var faqIcon = "bF_gN";
export var footerText = "bF_cD";
export var icon = "bF_bw";
export var iconContainer = "bF_b4";
export var iconText = "bF_gG";
export var immediate = "bF_gF";
export var inputContainer = "bF_cK";
export var linksSubtitle = "bF_gJ";
export var linksTitle = "bF_gH";
export var search = "bF_cJ";
export var searchInput = "bF_cL";
export var section = "bF_j";
export var selected = "bF_bg";
export var supportButton = "bF_gR";
export var supportLinks = "bF_gK";
export var top = "bF_l";
export var wave = "bF_gC";